export enum EVENT_TOPICS {
	NOTIFICATION_DISMISS_ALL = 'NOTIFICATION_DISMISS_ALL',
}
